module.exports = __webpack_public_path__ + "img/water-droplet-9.ea2d9d52.png";